export const names = [
  "1 Live Diggi",
  "100.5 The Katt",
  "101.5 UMFM",
  "101kv",
  "104.6 RTL Neue Hits",
  "106.9 Capital FM",
  "181.FM Beat",
  "181FM Old School HipHop/RnB",
  "181FM",
  "1FM",
  "1Mix House",
  "1Mix Trance",
  "2GB",
  "50 Style FM",
  "57 Chevy Radio",
  "630 CHED",
  "70s Hits",
  "80s Hits",
  "89.0 RTL in the MIX",
  "89.0 RTL LIVE",
  "89.1 Jazz",
  "8BitX",
  "93 Q",
  "93X Rocks",
  "95.2 Athens DJ",
  "95.5 Jazz",
  "96.3 Easy Rock",
  "977 Country Hits",
  "977 Hits",
  "98 FM",
  "98 Radio Rock",
  "987 Gen FM",
  "ABC Brisbane",
  "ABC Double J",
  "ABC Jazz",
  "ABC News",
  "ABC Triple J",
  "Abradio.cz",
  "Absolute Classic Rock",
  "Absolute Radio 80s",
  "Absolute Radio",
  "Ado FM",
  "AGF-Radio",
  "AGN Gaming NCS",
  "AH.FM",
  "Air1",
  "Airwave Radio",
  "Alaskan Media Radio",
  "Alicorn Radio",
  "AllWay",
  "AllZic Radio Enfant",
  "Ancient FM",
  "AnimeNFO",
  "Animes Station",
  "AniSonFM",
  "ANR",
  "Antena 1",
  "Antenne 1 Germany",
  "Antenne Bayern Top 40",
  "Antenne Bayern",
  "Antenne Kärnten",
  "Antenne Niedersachsen",
  "Antenne Salzburg",
  "Antenne Steiermark",
  "AntyRadio",
  "Arrow Classic Rock",
  "Audiobook Dla Dzieci",
  "AvtoRadio",
  "B101.5",
  "Baba Radio",
  "Bass-Clubbers",
  "Basso Radio",
  "BAYERN 3",
  "BBC 1Xtra",
  "BBC Asian Network",
  "BBC Coventry & Warwickshire",
  "BBC Essex",
  "BBC Hereford & Worcester",
  "BBC Newcastle",
  "BBC Radio 1",
  "BBC Radio 1xtra",
  "BBC Radio 2",
  "BBC Radio 3",
  "BBC Radio 4 Extra",
  "BBC Radio 4",
  "BBC Radio 4FM",
  "BBC Radio 4LW",
  "BBC Radio 5 Live Sportsball Extra",
  "BBC Radio 5 Live",
  "BBC Radio 6 Music",
  "BBC Radio Berkshire",
  "BBC Radio Bristol",
  "BBC Radio Cambridgeshire",
  "BBC Radio Cornwall",
  "BBC Radio Cumbria",
  "BBC Radio Derby",
  "BBC Radio Devon",
  "BBC Radio Foyle",
  "BBC Radio Gloucestershire",
  "BBC Radio Guernsey",
  "BBC Radio Humberside",
  "BBC Radio Jersey",
  "BBC Radio Kent",
  "BBC Radio Lancashire",
  "BBC Radio Leeds",
  "BBC Radio Leicester",
  "BBC Radio Lincolnshire",
  "BBC Radio London",
  "BBC Radio Manchester",
  "BBC Radio Merseyside",
  "BBC Radio Nan Gàidheal",
  "BBC Radio Norfolk",
  "BBC Radio Northampton",
  "BBC Radio Nottingham",
  "BBC Radio Oxford",
  "BBC Radio Scotland",
  "BBC Radio Sheffield",
  "BBC Radio Shropshire",
  "BBC Radio Solent",
  "BBC Radio Stoke",
  "BBC Radio Suffolk",
  "BBC Radio Tees",
  "BBC Radio Ulster",
  "BBC Radio Wales",
  "BBC Radio York",
  "BBC Somerset",
  "BBC Surrey",
  "BBC Sussex",
  "BBC Tees",
  "BBC Three Counties Radio",
  "BBC Wiltshire",
  "BBC WM 95.6",
  "BBC World Service News Stream",
  "BBC World Service UK Stream",
  "Besame",
  "Best of RMF",
  "Best Radio Turkey",
  "Bestpony Radio",
  "Beyond Radio",
  "BGRADIO",
  "Big B Radio K-POP",
  "Big FM",
  "Bitcoin Talk Radio",
  "Black Country Radio",
  "BluesNRock",
  "BNR News Radio",
  "BNR Nieuwsradio",
  "Bonn SU",
  "Breakz.FM",
  "Bremen NEXT",
  "BridgeFM",
  "Brony Radio Germany",
  "Bronydom Radio",
  "Bronytunes",
  "BURSTNation",
  "Bylgian",
  "Cadena100",
  "Capital South Coast",
  "Capital Tyne And Wear",
  "CapitalFM Edinburgh",
  "CapitalFM Liverpool",
  "CapitalFM London",
  "CapitalFM Manchester",
  "CapitalFM Moscow",
  "CapitalFM Nottinghamshire",
  "CapitalFM South & West Yorkshire",
  "CapitalFM South Wales",
  "CapitalFM XTRA London",
  "CarnivalFM",
  "Celestia Radio",
  "CeltCast",
  "Centova",
  "CFM",
  "CFOX",
  "CHOM FM",
  "Christian Hits",
  "Cidade FM",
  "Cima 100",
  "CityBeat FM 103.2",
  "CJNU Nostalgia Radio",
  "CJPX-FM",
  "CKIXFM",
  "Class 95",
  "Classic Hits",
  "Classic Rock Hits",
  "ClassicFM",
  "ClubTime.FM",
  "Clyde 1",
  "Clyde 2",
  "Clyde 3",
  "Coka-Cola FM Brazil",
  "Colorado Sound",
  "Columbia Estereo",
  "Contact FM",
  "ContactFR192",
  "Cooee Evolution",
  "Cool FM",
  "Cool Radio",
  "COPE",
  "Core Radio",
  "CoreTime.FM",
  "Corks 96FM",
  "Country Roads",
  "Dala FM",
  "Dalkas 88.2",
  "Dance Attack FM",
  "DASDING",
  "Death FM",
  "Deep Space Radio",
  "Derman Gibi Radyo",
  "Disney Latino",
  "DnB Station",
  "Dogglounge",
  "Downtown Radio",
  "Dorognoe Zlatoust",
  "DP P3",
  "DR P1",
  "DR P2",
  "DR P8",
  "Drive Radio",
  "Dromos FM",
  "DropRadio",
  "Dubbase FM",
  "Dublins 98FM",
  "Dublins FM104",
  "ECAV Radio",
  "EC Discord",
  "Echo of Moscow",
  "EHR Fresh",
  "EHR",
  "ElectroSwing FM",
  "Emissão RFM",
  "Energy981",
  "Energy Basel",
  "Energy Bern",
  "Energy Bremen",
  "Energy Digital",
  "Energy Hamburg",
  "Energie Montreal",
  "Energy München",
  "Energy Radio Germany",
  "Energy Radio Music",
  "Energy RU",
  "Energy Zurich",
  "EnergyFM",
  "EnkaRadio",
  "Enter Zagreb",
  "ERF Pop",
  "Eska Club",
  "Europa 2",
  "Europa FM",
  "EuropaPlus",
  "European Hit Radio",
  "EuroTruckRadio",
  "Evropa2",
  "Exclusively ABBA",
  "Express FM",
  "Extra FM",
  "Fajn Radio",
  "Falles Radio 7",
  "FalloutFM",
  "Fallout 1 FM",
  "Fallout 2 FM",
  "Fallout 3 FM",
  "Fallout 4 Diamond City",
  "Fallout 4 Classical Radio",
  "Fallout 4 MWTCF FM",
  "Fallout NV FM",
  "Fanboys Radio",
  "Fantasy 96,7",
  "Faro del Caribe",
  "FFH 80er",
  "FFN",
  "FG Radio",
  "FIP",
  "Fire Radio",
  "FlaixFM",
  "FlorFM",
  "Flux Radio",
  "FM 104",
  "FM Metro Manila",
  "FM4",
  "Folk BG",
  "Forth 1",
  "Fox News Radio",
  "Fragradio",
  "France Bleu Pays de Savoie",
  "France Culture",
  "France Musique",
  "Free Radio",
  "FreeThink Radio",
  "French Radio London",
  "Frequency NRJ",
  "Fresh 927",
  "Fréquence 3",
  "Fun 107",
  "Fun Radio",
  "Funx Dance Radio",
  "Futuradio Dance",
  "Futuradio Hits",
  "Futuradio Pop & Sweet",
  "Futuradio Rock",
  "FutureGeneration",
  "Gaydio",
  "gem",
  "GensokyoRadio",
  "GGRadio.net",
  "Gold 104.3",
  "Gold Music",
  "Gong FM",
  "Gr6 Explode FM",
  "GrindFM",
  "GtronicRadio",
  "HabLife Radio",
  "Hallam 2",
  "Hallam 3",
  "Hallam FM",
  "Hannover",
  "Happy Christmas Radio",
  "Happy Hardcore",
  "HardBase FM",
  "Hard FM Estonia",
  "Hard Rocken 80s",
  "HardBase.FM",
  "HardRadio.com",
  "Heard Well Radio",
  "Heart 80s",
  "Heart Berkshire",
  "Heart Bristol",
  "Heart FM colchester",
  "Heart Suffolk",
  "Heart",
  "Heart North Devon",
  "Heat Radio",
  "Hi FM Radio",
  "Hiper FM",
  "HipHop Radio",
  "Hit Radio 100% Hits",
  "HitFM Español",
  "HitFM",
  "HitMix",
  "Hitradio Ö3",
  "Hit Radio",
  "Hit West",
  "Hive365",
  "Hot 103.9",
  "Hot 108",
  "Hot 97",
  "Hot Hip Hop and R&B",
  "Hot Jamz 108",
  "HotmixRadio 2000",
  "HotmixRadio 80s",
  "HotmixRadio 90s",
  "HotmixRadio Dance",
  "HotmixRadio French",
  "HotmixRadio Funky",
  "HotmixRadio Game",
  "HotmixRadio Gold",
  "HotmixRadio HipHop",
  "HotmixRadio Hits",
  "HotmixRadio Hot",
  "HotmixRadio Lounge",
  "HotmixRadio Metal",
  "HotmixRadio New",
  "HotmixRadio Rock",
  "HotmixRadio Sunny",
  "HotmixRadio VIP",
  "Hot Jamz",
  "HouseTime.FM",
  "HPR1 Traditional Classic Country",
  "Hungama Radio",
  "Hunter.FM Country",
  "Hunter.FM Fresh",
  "Hunter.FM Hitz",
  "Hunter.FM Pop2K",
  "HunterFM",
  "Höre jetzt Energy Zürich",
  "ILoveRadio Top100 Dance & DJs",
  "ILoveRadio Top100 GermanProp",
  "ILoveRadio Top100 Germany",
  "ILoveRadio Top100 of 2018",
  "ILoveRadio Top100 Pop",
  "ILoveRadio Top100 US Hip Hop",
  "Itatiaia 95,7",
  "I Love 2 Dance",
  "I Love About Berlin",
  "I Love Bass!",
  "I Love Dreist",
  "I Love Harder Music",
  "I Love Radio HipHop TurnUp",
  "I Love Hits History",
  "I Love Mashup",
  "I Love Radio & Chill",
  "I Love Radio",
  "I Love The Battle",
  "I Love Top 100 Charts",
  "ImagineYourCraft",
  "Imperium Of Fire",
  "Impreza PL",
  "INITIAL D World",
  "Internet of Music",
  "IRadio",
  "Iraqi Mix Radio",
  "Irish Pub Radio",
  "ISKC Rock",
  "Israel Galgalatz 91.8 FM",
  "Israel 100 FM",
  "Iziba Live Radio",
  "JackFM Oxfordshire",
  "JACK 102.3 ",
  "JamFM",
  "JamFM NMR",
  "JapanFM",
  "Jazz Radio Blues",
  "JourneyScapes",
  "Jovem EDM",
  "Jovem NCS",
  "Jovem Pan FM SP",
  "Jovem POP",
  "Joy Turk",
  "K FM",
  "K Pop Replay",
  "K Pop Way",
  "K Rock 95.5 Geelong",
  "K-Love",
  "KEGN Radio",
  "Kerrang!",
  "Key 103",
  "Key 2",
  "Key 3",
  "KFM 99.9",
  "KFM Radio",
  "KickFM",
  "Kiss 98.5",
  "Kiss FM Melbourne",
  "Kiss FM Ukraine",
  "Kiss Fresh",
  "KissFM",
  "KissFM 98.0",
  "KissFM Spain",
  "KissFM Romania",
  "Kisstory",
  "KISW Rock",
  "Klocuchowe Radyjko",
  "KLIK FM",
  "KoolLondon",
  "Kossuth",
  "Kpopway Radio",
  "Kpop Music Radio Channel",
  "Kral FM",
  "KralPop",
  "KRISTALfm",
  "Kronehit",
  "KS 107.5",
  "LA 100",
  "Labor FM",
  "La Grosse Radio Metal",
  "La Radio Sans Pub",
  "laut.fm",
  "Laut FM Eins",
  "Laut FM Stelle",
  "LBC London",
  "Le Mouv",
  "Listen.moe",
  "Listen.moe K-Pop",
  "LittoralFM",
  "LoFi Hip Hop Radio",
  "LoFi Hip Hop Stream",
  "Loop",
  "Los40 Principales",
  "Los40",
  "Love FM Manila",
  "Luna Radio",
  "M-1",
  "M80 España",
  "M80 Portugal",
  "Magic Chilled",
  "Magic",
  "Magic 89.9",
  "Mai FM",
  "Martini In The Morning",
  "MDR Jump",
  "MDR SPUTNIK",
  "Mega 105.1",
  "Mega FM",
  "MegaHits",
  "MegaStarFM",
  "Mellow Magic",
  "Metal FM",
  "Metal Maxium Radio",
  "Metal Nation",
  "Metro FM",
  "Metro Radio",
  "METROPOL FM",
  "MFR",
  "Mix FM ES",
  "Mix Lite",
  "Mix Megapol",
  "Mix FM SA",
  "MixFM",
  "Mixx FM",
  "MNM",
  "Monster RX 93.1",
  "Monstercat",
  "Monstercat Instinct",
  "Moose FM",
  "Mubert Ambient",
  "Mubert Chillstep",
  "Mubert Deephouse",
  "Mubert Liquidfunk",
  "Mubert Psytrance",
  "Mubert Trap",
  "MultiAnime Radio",
  "Music FM",
  "Musical 97.5",
  "Mutekiradio",
  "Muzo",
  "myROCK",
  "Máxima FM",
  "NabboFM",
  "Najwieksze Polskie Przeboje",
  "Narodni Radio",
  "Nashe Radio",
  "Nation Radio",
  "Naxi 80e Radio",
  "NDR Welle Nord",
  "Nightwave Plaza",
  "Nile FM",
  "NeXuS Radio",
  "NJOY Bulgaria",
  "NJOY Germany",
  "NoCopyrightSounds",
  "Nogoum FM",
  "NonStopPlay",
  "Northsound 1",
  "Nostalgie NL",
  "Nostalgie",
  "Nova 919",
  "NOVA Direkte",
  "Nova FM",
  "Nova",
  "NPO Radio 1",
  "NPO Radio 2",
  "NPR News",
  "NPR Station",
  "NRJ Basel",
  "NRJ Belgium",
  "NRJ BG",
  "NRJ Energy Zuerich",
  "NRJ Finnish",
  "NRJ FR",
  "NRJ Sweden",
  "NRJ",
  "NRK Alltid Nyheter",
  "NRK Folkemusikk",
  "NRK Jazz",
  "NRK Klassisk",
  "NRK mP3",
  "NRK P1 Buskerud",
  "NRK P1 Finnmark",
  "NRK P1 Hedmark og Oppland",
  "NRK P1 Hordaland",
  "NRK P1 Møre og Romsdal",
  "NRK P1 Nordland",
  "NRK P1 Rogaland",
  "NRK P1 Sogn og Fjordane",
  "NRK P1 Sørlandet",
  "NRK P1 Telemark",
  "NRK P1 Troms",
  "NRK P1 Trøndelag",
  "NRK P1 Vestfold",
  "NRK P1 Østfold",
  "NRK P1+",
  "NRK P13",
  "NRK P2",
  "NRK P3 National Rap Show",
  "NRK P3 Radioresepsjonen",
  "NRK P3 Urørt",
  "NRK P3",
  "NRK Radio P3",
  "NRK Sport",
  "NRK Super",
  "NRK Sápmi",
  "Numberone FM",
  "Oasis 100.1 FM",
  "Olimpica Stereo",
  "OK Radio",
  "OKLM Radio",
  "Orbital",
  "OriginUK Radio",
  "Ostseewelle Hit Radio",
  "Otvoreni",
  "P3",
  "P5Bergen",
  "P5NonStopHits",
  "P8Pop",
  "Paraten Radio",
  "Party FM",
  "Party Mix Latino",
  "Petofi",
  "Pinguin Radio",
  "Planet Rock",
  "PlanetRadio",
  "Play.cz",
  "Play Radio RS",
  "PonyvilleFm",
  "Pop Hits",
  "Power181",
  "PowerHitRadio Estonia",
  "PowerHitRadio Lithuania",
  "PowerPonies Radio",
  "PowerTurk",
  "Prambors FM",
  "PRL24",
  "Pro FM",
  "ProFM",
  "Pulse EDM",
  "PulseEDM",
  "Punjabi FM",
  "Pura Vida",
  "Q107.5",
  "Q Teja",
  "Q-dance",
  "Qmusic",
  "Qmusic BE",
  "Qmusic Foute Uur",
  "Qmusic nonstop",
  "Q Music nonstop",
  "R.SH",
  "R101",
  "RAC1 (Catalunya)",
  "RAC105",
  "Rad.io",
  "Radio 10",
  "Radio 100",
  "Radio 105",
  "Radio 107.7",
  "Radio 10 Guilty Pleasures",
  "Radio 24 Zurich",
  "Radio 3FM",
  "Radio 538",
  "Radio 538 Party",
  "Radio 912",
  "Radio Aire 2",
  "Radio Aire 3",
  "Radio Aire",
  "Radio Activa",
  "Radio Aktual",
  "Radio Alpha",
  "Radio AS FM",
  "Radio B-Zone",
  "Radio Bahia Puntarenas",
  "Radio Banovina",
  "Radio Banovina Light",
  "Radio Banovina Turbo",
  "Radio Beograd",
  "Radio Bielefeld",
  "Radio Bob",
  "Radio Bollerwagen",
  "Radio Borders",
  "Radio Campus",
  "Radio Casino",
  "Radio Centras",
  "Radio City 2",
  "Radio City 3",
  "Radio City 91.1",
  "Radio City BG",
  "Radio City Talk",
  "Radio City",
  "Radio Chablais",
  "Radio Classique",
  "Radio Club FG",
  "Radio Condestavel",
  "Radio Comercial",
  "Radio Cool Focsani",
  "Radio Cristal",
  "Radio Cymru",
  "Radio Darom 101.5 FM",
  "Radio Deep Romania",
  "Radio Disney Brazil",
  "Radio Disney Costa Rica",
  "Radio Dos",
  "Radio ESKA",
  "Radio Evropa 2",
  "Radio FEST",
  "Radio FFH",
  "Radio FG",
  "Radio Flaixbac",
  "Radio FM4",
  "RadioFM Spain",
  "Radio Freee",
  "Radio Fritz",
  "Radio Globo Italia",
  "Radio Gong Würzburg",
  "Radio Gra Torufi",
  "Radio Gra Worclaw",
  "Radio Hamburg",
  "Radio Hit",
  "Radio Hits 88.2",
  "Radio Hyrule",
  "Radio Impuls",
  "Radio Impuls RO",
  "Radio IQ",
  "Radio Köln",
  "Radio Malphais",
  "Radio Manele",
  "Radio Maria",
  "Radio Marte",
  "Radio Maryja",
  "Radio Masr",
  "Radio Metropolitana FM",
  "Radio Mirchi 98.3",
  "Radio Monte Carlo",
  "Radio Neandertal",
  "Radio New Zealand National",
  "Radio Niederosterreich",
  "Radio Nova",
  "Radio Nova Era",
  "Radio NTI",
  "Radio Oasis 100.1",
  "Radio Paloma",
  "Radio Pineapple FM",
  "Radio Province",
  "Radio PSR",
  "Radio Record",
  "Radio Regenbogen",
  "Radio Rijnmond",
  "Radio Rock",
  "Radio SAW",
  "Radio Sauerland",
  "Radio Severozapad",
  "Radio Skonto",
  "Radio Solar",
  "Radio Sonata",
  "Radio Squad",
  "Radio Stad Den Haag",
  "Radio Suomipop",
  "Radio SWH",
  "Radio SWR3",
  "Radio Taraf",
  "Radio Teddy",
  "Radio Televizua Banovina",
  "Radio TSC",
  "Radio Trsat",
  "Radio Unicorn",
  "Radio Veronica",
  "Radio Viborg",
  "Radio Vocaloid",
  "Radio X Manchester",
  "Radio X UK",
  "Radio X",
  "Radio ZET",
  "Radio ZU",
  "Radio Zürichsee",
  "Radio1 BG",
  "Radio1 hungary",
  "Radio1 Rock BG",
  "Radio1",
  "Radio912",
  "Radio999BG",
  "Radiobrony French",
  "RadioCentras",
  "Radiofonia",
  "RadioFreshBG",
  "Radioharu",
  "RadioMetro RU",
  "Radiotedu",
  "Radyo Fenomen Pop",
  "Radyo Fenomen",
  "Radyo Odtu",
  "Rainwave Chiptune",
  "Rainwave Covers",
  "Rainwave Game",
  "Rainwave OC Remix",
  "Rainwave",
  "Raute Music HappyHardCore",
  "Raute Music Harder",
  "Raute Musik 12Punks",
  "Raute Musik 90s",
  "Raute Musik BigCityBeats",
  "Raute Musik Chart Hits",
  "Raute Musik Club",
  "Raute Musik Country",
  "Raute Musik DAS Coachingradio",
  "Raute Musik Deutschrap",
  "Raute Musik Goldies",
  "Raute Musik GYS",
  "Raute Musik Happy",
  "Raute Musik House",
  "Raute Musik Jam",
  "Raute Musik Klassik",
  "Raute Musik Lounge",
  "Raute Musik LoveHits",
  "Raute Musik Oriental",
  "Raute Musik Partyhits",
  "Raute Musik Salsa",
  "Raute Musik Schlager",
  "Raute Musik Sex",
  "Raute Musik Solo Piano",
  "Raute Musik TechHouse",
  "Raute Musik Top 40",
  "Raute Musik Trance",
  "Raute Musik Trap",
  "Raute Musik Traurig",
  "Raute Musik Volksmusik",
  "Raute Musik Wacken Radio",
  "Raute Musik Workout",
  "Raute Musik",
  "Raw FM",
  "Rádio FM 98 BH",
  "Rádio Transamérica 101.3 FM",
  "RDS Italia",
  "Record Megamix",
  "Record Deep",
  "Record EDM",
  "Record Future House",
  "Record Trancemission",
  "Record Chill-Out",
  "Record Minimal/Tech",
  "Record Pirate Station",
  "Record Russian Mix",
  "Record Vip House",
  "Record Superdisco 90s",
  "Record Breaks",
  "Record Dubstep",
  "Record Dancecore",
  "Record Techno",
  "Record Hardstyle",
  "Record Trap",
  "Record Pump",
  "Record Rock",
  "Record Medlyak FM",
  "Record Gop FM",
  "Record Yo!FM",
  "Record Rave FM",
  "Red FM 93.5",
  "Reggae World Radio",
  "Reggaeton Colombia",
  "Reggaeton Y Mas",
  "Relax Gold",
  "Relax Jazz",
  "Relax Latino",
  "Relax Life",
  "Relax Nature",
  "Relax and Unwind",
  "reVoice",
  "Revolution935",
  "RFM FR",
  "Rinse FM",
  "Rire & Chansons",
  "Riviera Radio",
  "RIX FM",
  "RMC",
  "RMF 2 Pop",
  "RMF 2000",
  "RMF 2010",
  "RMF 25 Lat FM",
  "RMF 3 Pop-Rock",
  "RMF 4 Dance & RNB",
  "RMF 50s",
  "RMF 60s",
  "RMF 70s Disco",
  "RMF 70s",
  "RMF 80s Disco",
  "RMF 80s",
  "RMF 90s Dance",
  "RMF 90s",
  "RMF Alternatywa",
  "RMF Baby",
  "RMF Ballady",
  "RMF BeatleMania",
  "RMF Blues",
  "RMF Bravo",
  "RMF Celtic",
  "RMF Chillout",
  "RMF Chopin",
  "RMF Classic Rock",
  "RMF Classic",
  "RMF Club",
  "RMF Cuba",
  "RMF Dance",
  "RMF Depeche Mode",
  "RMF Disco Polo",
  "RMF Disco",
  "RMF Elvis",
  "RMF Fitness Rock",
  "RMF Fitness",
  "RMF FM",
  "RMF Francais",
  "RMF Funk",
  "RMF Game",
  "RMF Gold",
  "RMF Grunge",
  "RMF Hard & Heavy",
  "RMF Hip Hop",
  "RMF Hot New",
  "RMF Koledy",
  "RMF Lady Pank",
  "RMF Lagodne Przeboje",
  "RMF Latino",
  "RMF Love",
  "RMF Maxxx Hop Bec",
  "RMF Maxxx",
  "RMF Michael Jackson",
  "RMF Musika Klasyczna",
  "RMF Muzyka Filmowa",
  "RMF Niezapomniane Melodie",
  "RMF Party",
  "RMF Piosenka Literacka",
  "RMF Ploski Hip Hop",
  "RMF Ploski Rock",
  "RMF Ploskie Prezeboje",
  "RMF Polista",
  "RMF Polska Prywatka",
  "RMF PRL",
  "RMF Queen",
  "RMF Reggae",
  "RMF Relaks",
  "RMF RnB",
  "RMF Rock Progresywny",
  "RMF Rock",
  "RMF Sloneczne Przeboje",
  "RMF Smooth Jazz",
  "RMF Studencka Impreza",
  "RMF Styl",
  "RMF Swieta",
  "RMF Szanty",
  "RMF Teksciory",
  "RMF Top 30 Dance",
  "RMF Top 30 Disco Polo",
  "RMF Top 30 Pl",
  "RMF Top 30 Pop",
  "RMF Top 30 Rock",
  "RMF Top 30 Swieta",
  "RMF Trend Sounds",
  "RMF W Pracy",
  "RNZ Concert",
  "RNZ National",
  "RNZ Pacific/International",
  "RNZ Parliament",
  "Rock FM 2",
  "Rock FM 3",
  "Rock FM Classic",
  "Rock FM",
  "Rock Hits",
  "Rock Klassiker",
  "Rockland Radio",
  "RSG Radio",
  "RTL2",
  "RTS Couleur 3",
  "RTV Noord",
  "RTV Zwolle FM",
  "Russian Songs",
  "RVA Radio",
  "RQP 104.5 FM",
  "Salut cest cool",
  "SBS Pop Asia",
  "SCHLAGERPARTY",
  "Schwarzwaldradio",
  "Sea Shanty Radio",
  "Signal 1",
  "Select UK",
  "SimLiveRadio",
  "Simulator FM",
  "Simulator Radio",
  "Sinfonola",
  "Sizeer FM",
  "Skeetown Stereo",
  "Sky 106",
  "Sky Radio Christmas",
  "Sky Radio Dance",
  "Sky Radio Estonia",
  "Sky Radio Gold",
  "Sky Radio",
  "Skyplus Radio",
  "Skyrock FM",
  "Slam Hardstyle",
  "Slam Nonstop",
  "Slam",
  "Slow Turk",
  "Smash FM",
  "Smooth Jazz",
  "Smooth Radio",
  "Soma FM",
  "Soma FM Bagel",
  "Soma FM Beat Blender",
  "Soma FM Black Rock FM",
  "Soma FM Boot Liquor",
  "Soma FM Cliqhop IDM",
  "Soma FM Covers",
  "Soma FM Deep Space One",
  "Soma FM DEF CON Radio",
  "Soma FM Digitallis",
  "Soma FM Drone Zone",
  "Soma FM Dubstep Beyond",
  "Soma FM Fluid",
  "Soma FM Folk Forward",
  "Soma FM Groove Salad",
  "Soma FM Illionis Street Lounge",
  "Soma FM Indie Pop Rocks",
  "Soma FM Left Coast 70s",
  "Soma FM Lush",
  "Soma FM Metal Detector",
  "Soma FM Mission Control",
  "Soma FM PopTron",
  "Soma FM SF 10-33",
  "Soma FM Secret Agent",
  "Soma FM Seven inch Soul",
  "Soma FM Sonic Universe",
  "Soma FM Space Station Soma",
  "Soma FM Suburbs of Goa",
  "Soma FM The Trip",
  "Soma FM Thistle Radio",
  "Soma FM Underground 80s",
  "SONIC 102.9",
  "South America Memes",
  "Space Travel Radio",
  "Spin 1038",
  "Spirit1053",
  "SR P3",
  "SRF3",
  "Star 102.5",
  "Star FM Berlin",
  "Star FM Latvia",
  "StayRadio",
  "Stereo Vision",
  "Stray FM",
  "StuBru",
  "Studio Alphen",
  "Studio Brussel",
  "Südtirol 1",
  "Sunrise Radio",
  "Sunshine Live",
  "Super FM",
  "Swansea Bay Radio",
  "Swansea Sound",
  "Sweet FM",
  "Swiss Radio Pop",
  "SWR3",
  "Symbiosis FM",
  "Tab Out Radio",
  "Taksim FM",
  "Tay FM",
  "TDI Radio",
  "TeaTime.FM",
  "Technobase FM",
  "Teletaxi",
  "Teletica Radio",
  "Tempo FM",
  "TFLive",
  "TFM",
  "The Arrow",
  "The Base",
  "The Breeze",
  "The Breeze Portsmouth",
  "The Eagle 100.9 FM Amarillo",
  "The Goat",
  "The Hits Radio",
  "The Sound",
  "The UK 1940s",
  "The Voice Denmarks Hitstation",
  "TheFatRat",
  "TheWave",
  "Third Rock Radio",
  "Tiare FM",
  "Todays Hits",
  "TOGA Radio",
  "Tonic Lyon",
  "Top100Station",
  "Top of the Charts",
  "TopMusic 95.80",
  "Topp40",
  "Toulouse FM",
  "TranceBase.FM",
  "Trap FM",
  "Trap Line FM",
  "Triplag Dark",
  "Triple J",
  "Triple X Radio",
  "TRT Radyo 1",
  "Truckers FM",
  "Trucking Nation FM",
  "TSF",
  "TSN 1150",
  "TSN 1200",
  "Tuks FM",
  "Turk Truck Radio",
  "UHRadioCitizen",
  "UK RAW Radio",
  "Ultra",
  "Union JACK",
  "Unity NU",
  "UpBeat",
  "Urban Space Radio",
  "Urgent FM",
  "Vape Radio",
  "Venus FM",
  "Veronica Rock Radio",
  "Veronika",
  "VersRadio",
  "VibeFM",
  "Vibes Radio",
  "Virgin Radio Turkey",
  "Viking FM",
  "Vinyl FM",
  "Virgin Radio Romania",
  "Virgin Radio",
  "VirtualTruckRadio",
  "Vocaloid Radio",
  "Voices of Asgardia",
  "Voscast",
  "Vybez Station",
  "WAO",
  "Wargaming FM",
  "Wave 105",
  "WDR 1LIVE diGGi",
  "WCPT",
  "WDR 1LIVE",
  "WDR 2",
  "WDR 3",
  "WDR 4",
  "We Are GA",
  "West FM",
  "Westside Radio",
  "Westsound",
  "WGN Radio 720",
  "Wild Soul Child Radio",
  "Willie 103.5",
  "Wish 107.5",
  "Wissen in 60 Sekunden",
  "WitFM",
  "WKND",
  "WMPG",
  "WS-FM",
  "WSAS91A",
  "WSFM",
  "Wyoming Rocks",
  "X 95.7",
  "X Music Online",
  "XitFm",
  "Xtreme Radio",
  "Yasmin Radio",
  "YesFM",
  "Yggdrassil Radio",
  "YouFM",
  "Your Classical",
  "Z-Rock",
  "Z88.3",
  "ZaycevFM Club",
  "ZET 2000",
  "ZET 80",
  "ZET 90",
  "ZET Dance",
  "ZET Hit",
  "ZET Hot",
  "ZET Kids",
  "ZET Party",
  "ZET PL",
  "ZET Rock",
  "ZetlandFM",
  "Zip FM"
];



// WEBPACK FOOTER //
// ./src/routes/radios/names.js